import type { ReactNode } from 'react';
import type { FieldErrors } from './memberErrors';

export function Field({
  label,
  name,
  errors,
  children,
  hint,
}: {
  label: string;
  name: string;
  errors: FieldErrors;
  children: ReactNode;
  hint?: string;
}) {
  const messages = errors[name] ?? [];
  return (
    <div className="member-field">
      <label className="form-label-outside" htmlFor={name}>
        {label}
      </label>
      {children}
      {hint && !messages.length ? <p className="member-hint">{hint}</p> : null}
      {messages.map((m) => (
        <p key={m} className="member-error">
          {m}
        </p>
      ))}
    </div>
  );
}

export function FormNotice({ kind, children }: { kind: 'error' | 'info'; children: ReactNode }) {
  return <div className={`member-notice member-notice-${kind}`}>{children}</div>;
}
